// extracted by mini-css-extract-plugin
module.exports = {"menuList":"MenuList_menuList__2k08S"};